export const pageRouterPlugin = () => {
	console.log('Page Router Plugin Not Implemented Yet');
};
